/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable @typescript-eslint/consistent-type-definitions */
/* eslint-disable import/no-internal-modules */
import { TagCloud } from '@insided/deprecated-preact-components/tag-cloud'
import { HTMLWidget } from '@insided/deprecated-preact-components/html-widget/HTMLWidget'
import { QuickLinksManager } from '@insided/deprecated-preact-components/quick-links/QuickLinksManager'
import { TabsConfigurator } from '@insided/deprecated-preact-components/homepage-tabs/TabsConfigurator'
import { FeaturedTopicsConfigurator } from '../../Navigation/widget-featured-topics/FeaturedTopicsConfigurator'
import FeatureTopicsModeratorTagsWithHelp from '@insided/deprecated-preact-components/homepage/FeaturedTopicsModeratorTags'
import CommunityStatisticsConfigurator from '@insided/deprecated-preact-components/widget-community-statistics/configurator'

import { BadgesConfigurator } from '@insided/deprecated-preact-components/widget-badges/configurator'
import { SolvedTopicsConfigurator } from '@insided/deprecated-preact-components/widget-solved-topics/configurator'
import { MostLikedConfigurator } from '@insided/deprecated-preact-components/widget-most-liked/configurator'
import { RecommendationsWidgetConfigurator } from '@insided/deprecated-preact-components/widget-recommendations/configurator'
import LeaderboardPointsConfig from '@insided/deprecated-preact-components/widget-leaderboard-points-config'
import FeaturedSidebarWithHelp from '@insided/deprecated-preact-components/widget-notification/featuredSidebar'
import CommunityConfigurator from '@insided/deprecated-preact-components/community-category/configurator'
import BannerConfigurator from '@insided/deprecated-preact-components/widget-banner/configurator'
import KnowledgeBaseConfigurator from '@insided/deprecated-preact-components/knowledge-base/configurator'
import { EventCalendarConfigurator } from '@insided/deprecated-preact-components/widget-events-calendar/configurator'
import { GroupsWidgetConfigurator } from '@insided/deprecated-preact-components/widget-groups/configurator'
import { Buttons } from '@insided/deprecated-preact-components/widget-groups/buttons'
import IdeationPipelineConfigurator from '@insided/deprecated-preact-components/ideation-destination/configurator'
import GenericHeroConfigurator from '@insided/destination/modules/Navigation/WidgetGenericHero/GenericHeroConfigurator'
import HeaderNavigationConfiguration from '@insided/deprecated-preact-components/mega-menu/configurator'
import WidgetContainerConfigFields from './WidgetContainerConfigFields'
import { DynamicContentConfigurator } from '@insided/destination/modules/Navigation/widget-dynamic-content/DynamicContentConfigurator'
import { FunctionalComponent } from 'preact'
import { TimeRanges } from '@insided/deprecated-preact-components/widget-points-leaderboard/indexWidget.sync'
import { WidgetSetting } from '@insided/deprecated-preact-components/mega-menu/Types'
import TopicBannerWithHelp, {
  TopicBannerData
} from '@insided/deprecated-preact-components/topic-banner/TopicBannerWithHelp'
import { BannerElementConfig } from '@insided/deprecated-preact-components/widget-banner/index.sync'
import { FeaturedTopicsConfig } from '@insided/destination/modules/Navigation/widget-featured-topics/index.sync'
import { EventsCalendarWidgetConfig } from '@insided/deprecated-preact-components/widget-events-calendar/index.sync'
import { CategoryAndContentStreamConfig } from '@insided/deprecated-preact-components/widget-category-and-topic-stream/index.sync'
import { KnowledgeBaseWidgetConfig } from '@insided/deprecated-preact-components/knowledge-base/index.sync'
import { RecommendationsWidgetConfig } from '@insided/deprecated-preact-components/widget-recommendations/Recommendations.sync'
import { IdeationPipelineConfig } from '@insided/deprecated-preact-components/ideation-destination/Pipeline.sync'
import { GroupsWidgetConfig } from '@insided/deprecated-preact-components/widget-groups/index.sync'
import { CommunityCategoryConfig } from '@insided/deprecated-preact-components/community-category/index.sync'
import { DynamicContentConfig } from '@insided/destination/modules/Navigation/widget-dynamic-content/index.sync'

import { ServerGenericPageWidget, WidgetSettings } from '@insided/customization'
import { GenericHeroConfig } from '@insided/destination/modules/Navigation/WidgetGenericHero/index.sync'

export interface PageWidget<T, C extends Record<string, unknown>> {
  id: number
  type: T
  active: boolean
  title: string
  config: C
  settings: WidgetSettings
}

type QuickLinksConfig = {
  borderRadius: number
  enableBorder: boolean
  quickLinks: Array<{
    id: string
    title: string
    description: string
    openNewTab: boolean
    iconSrc: null | string
    imageSrc: null | string
    url: string
  }>
}

type CommunityStatisticsConfig = {
  total_topics: boolean
  total_comments: boolean
  total_users: boolean
}

type Container21Config = {
  column_1: ServerGenericPageWidget[]
  column_2: ServerGenericPageWidget[]
}

type LeaderboardPointsConfigType = {
  maxResults: number
  excludeUserRole: string[]
  timeRange: TimeRanges[]
  emptyMessage: string
  isPreviewEmptyMessage: boolean
  showLink: boolean
  linkText: string
  showLoggedInUserSection: boolean
}

type HeaderNavigationConfig = {
  items: WidgetSetting[]
  logo: string
}

export type AnyWidgetConfiguration =
  | PageWidget<
      | 'header'
      | 'navigation_bar'
      | 'statistics_bar'
      | 'introduction_bar'
      | 'feature_topics'
      | 'announcement_card'
      | 'breadcrumb'
      | 'footer'
      | 'ideation_list'
      | 'ideation_statistics_bar'
      | 'group_overview',
      {}
    >
  | PageWidget<'container_2_1', Container21Config>
  | PageWidget<'announcement_card', {}>
  | PageWidget<'badges', { amount: number }>
  | PageWidget<'banner', BannerElementConfig>
  | PageWidget<'category_and_topics_stream_only', CategoryAndContentStreamConfig>
  | PageWidget<'community_category', CommunityCategoryConfig>
  | PageWidget<'community_statistics', CommunityStatisticsConfig>
  | PageWidget<'dynamic_content', DynamicContentConfig>
  | PageWidget<'event_calendar', EventsCalendarWidgetConfig>
  | PageWidget<'featured_topics', FeaturedTopicsConfig>
  | PageWidget<'generic_hero', GenericHeroConfig>
  | PageWidget<'groups', GroupsWidgetConfig>
  | PageWidget<'header_navigation', HeaderNavigationConfig>
  | PageWidget<'hero_banner', GenericHeroConfig>
  | PageWidget<'html_widget', { html: string }>
  | PageWidget<'ideation_hero', GenericHeroConfig>
  | PageWidget<'ideation_list', {}>
  | PageWidget<'ideation_pipeline', IdeationPipelineConfig>
  | PageWidget<'ideation_statistics_bar', {}>
  | PageWidget<'ideation_status_filter', {}>
  | PageWidget<'introduction_bar', {}>
  | PageWidget<'knowledge_base', KnowledgeBaseWidgetConfig>
  | PageWidget<'leaderboard_points', LeaderboardPointsConfigType>
  | PageWidget<'most_liked', { amount: number; period: number }>
  | PageWidget<'product_area_filter', {}>
  | PageWidget<'product-updates_hero', GenericHeroConfig>
  | PageWidget<'quick_links', QuickLinksConfig>
  | PageWidget<'recommendations', RecommendationsWidgetConfig>
  | PageWidget<'solved_topics', { amount: number }>
  | PageWidget<'statistics_bar', {}>
  | PageWidget<'tag_cloud', { amount: number }>
  | PageWidget<'topic_banner', { selectedTopic: TopicBannerData | null }>

const withDerivedTitle = <T extends { title?: string | undefined }>(config: T, titleToOverride?: string) => {
  /**
   * Initially certain components got their title from `widget.title` directly, not from `widget.config.title`
   * This code uses the second argument as a replacement for the actual title passed to the component
   */
  if (titleToOverride) {
    return {
      ...config,
      title: titleToOverride
    }
  }
  return config
}

export interface WidgetConfigurationProps {
  widget: AnyWidgetConfiguration
  onChange: (payload: Pick<AnyWidgetConfiguration, 'type' | 'config' | 'title'>) => void
  onConfigChange: (payload: AnyWidgetConfiguration['config']) => void
  controlUrl: string
  nested: boolean
}

export const WidgetConfiguration: FunctionalComponent<WidgetConfigurationProps> = ({
  widget,
  onChange,
  onConfigChange,
  nested,
  controlUrl
}) => {
  if (widget.type === 'html_widget') {
    return (
      <HTMLWidget
        title={widget.title}
        content={widget.config.html}
        deleteButtonAction={() => {}}
        onChange={({ html, title }) => {
          onChange({
            config: { html },
            type: widget.type,
            title: title
          })
        }}
        hideDeleteButton
      />
    )
  }
  if (widget.type === 'knowledge_base') {
    return (
      <WidgetContainerConfigFields
        config={withDerivedTitle(widget.config, widget.title)}
        widgetName='knowledge-base'
        nested={nested}
        onChange={onConfigChange}
        additionalConfigurations={<KnowledgeBaseConfigurator content={widget.config} onChange={onConfigChange} />}
      >
        <div className='widget-configuration_info-box'>
          <strong>✨ How to edit knowledge base cards</strong>
          <p>
            Please go to{' '}
            <a target='_blank' rel='noreferrer' href={`${controlUrl}/platform/knowledge-base`}>
              knowledge base category overview in control
            </a>{' '}
            to reorder the categories. And in each parent category page, you can change title, description or visual of
            individual cards.
          </p>
        </div>
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'quick_links') {
    return (
      <QuickLinksManager
        isActive
        onChange={(config) => {
          onChange({
            type: widget.type,
            title: config.title,
            config: {
              quickLinks: config.quickLinks.map((link) => ({
                ...link,
                iconSrc: link.iconSrc,
                imageSrc: link.imageSrc,
                openNewTab: link.openNewTab
              })),
              enableBorder: config.settings.enableBorder,
              borderRadius: config.settings.borderRadius
            }
          })
        }}
        title={widget.title}
        quickLinks={widget.config.quickLinks.map((link) => ({
          ...link,
          icon_src: link.iconSrc,
          image_src: link.imageSrc,
          target: link.openNewTab
        }))}
        settings={{
          borderRadius: widget.config.borderRadius,
          enableBorder: widget.config.enableBorder
        }}
      />
    )
  }
  if (widget.type === 'category_and_topics_stream_only') {
    return (
      <WidgetContainerConfigFields
        nested={nested}
        config={widget.config}
        widgetName='category-and-topics-stream'
        onChange={onConfigChange}
      >
        <TabsConfigurator
          tabs={widget.config.tabs}
          // eslint-disable-next-line @gorazdo/preact/prefer-classname
          class='tabs-configurator--wide'
          onChange={(config) => {
            onConfigChange({
              tabs: config.tabs
            })
          }}
        />
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'recommendations') {
    return (
      <WidgetContainerConfigFields
        config={withDerivedTitle(widget.config, widget.title)}
        widgetName='recommendations'
        nested={nested}
        onChange={onConfigChange}
      >
        <RecommendationsWidgetConfigurator content={widget.config} onChange={onConfigChange} />
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'featured_topics') {
    return (
      <WidgetContainerConfigFields
        config={withDerivedTitle(widget.config, widget.title)}
        widgetName='featured-topics'
        nested={nested}
        onChange={onConfigChange}
      >
        <FeaturedTopicsConfigurator content={widget.config} onChange={onConfigChange} />
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'dynamic_content') {
    return (
      <WidgetContainerConfigFields
        config={withDerivedTitle(widget.config, widget.title)}
        widgetName='dynamic-content'
        nested={nested}
        onChange={onConfigChange}
      >
        <DynamicContentConfigurator content={widget.config} onChange={onConfigChange} />
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'leaderboard_points') {
    return (
      <LeaderboardPointsConfig
        title={widget.title}
        content={widget.config}
        controlUrl={controlUrl}
        onChange={(config) => {
          onChange({
            type: widget.type,
            title: config.title,
            config: {
              maxResults: config.maxResults,
              excludeUserRole: config.excludeUserRole,
              timeRange: config.timeRange,
              emptyMessage: config.emptyMessage,
              isPreviewEmptyMessage: config.isPreviewEmptyMessage,
              showLink: config.showLink,
              linkText: config.linkText,
              showLoggedInUserSection: config.showLoggedInUserSection
            }
          })
        }}
      />
    )
  }
  if (widget.type === 'tag_cloud') {
    return (
      <TagCloud
        title={widget.title}
        amount={widget.config.amount}
        onChange={(config) => {
          onChange({
            type: widget.type,
            title: config.title,
            config: {
              amount: config.amount
            }
          })
        }}
      />
    )
  }
  if (widget.type === 'badges') {
    return (
      <BadgesConfigurator
        title={widget.title}
        amount={widget.config.amount}
        onChange={(config) => {
          onChange({
            type: widget.type,
            title: config.title,
            config: { amount: config.amount }
          })
        }}
      />
    )
  }
  if (widget.type === 'event_calendar') {
    return (
      <WidgetContainerConfigFields
        nested={nested}
        config={withDerivedTitle(widget.config, widget.title)}
        widgetName='event-calendar'
        onChange={onConfigChange}
      >
        <EventCalendarConfigurator content={widget.config} onChange={onConfigChange} />
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'groups') {
    return (
      <WidgetContainerConfigFields
        nested={nested}
        config={withDerivedTitle(widget.config, widget.title)}
        widgetName={widget.type}
        onChange={onConfigChange}
        additionalConfigurations={<Buttons config={widget.config} onChange={onConfigChange} />}
      >
        <GroupsWidgetConfigurator config={widget.config} onChange={onConfigChange} />
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'solved_topics') {
    return (
      <SolvedTopicsConfigurator
        title={widget.title}
        amount={widget.config.amount}
        onChange={(config) => {
          onChange({
            type: widget.type,
            title: config.title,
            config: { amount: config.amount }
          })
        }}
      />
    )
  }
  if (widget.type === 'most_liked') {
    return (
      <MostLikedConfigurator
        title={widget.title}
        amount={widget.config.amount}
        period={widget.config.period}
        onChange={(config) => {
          onChange({
            type: widget.type,
            title: config.title,
            config: {
              amount: config.amount,
              period: config.period
            }
          })
        }}
      />
    )
  }
  if (widget.type === 'community_statistics') {
    return (
      <CommunityStatisticsConfigurator
        title={widget.title}
        showTotalTopics={widget.config.total_topics}
        showTotalComments={widget.config.total_comments}
        showTotalUsers={widget.config.total_users}
        onChange={(config) => {
          onChange({
            type: widget.type,
            title: config.title,
            config: {
              total_topics: config.showTotalTopics,
              total_comments: config.showTotalComments,
              total_users: config.showTotalUsers
            }
          })
        }}
      />
    )
  }
  if (widget.type === 'feature_topics') {
    return <FeatureTopicsModeratorTagsWithHelp />
  }
  if (widget.type === 'announcement_card') {
    return <FeaturedSidebarWithHelp />
  }
  if (widget.type === 'topic_banner') {
    return (
      <TopicBannerWithHelp
        config={widget.config}
        onChange={(config) => {
          onChange({
            type: widget.type,
            title: 'Topic banner',
            config: {
              selectedTopic: config.selectedTopic
            }
          })
        }}
      />
    )
  }
  if (widget.type === 'community_category') {
    return (
      <WidgetContainerConfigFields
        config={withDerivedTitle(widget.config, widget.title)}
        widgetName='community-category'
        nested={nested}
        onChange={onConfigChange}
        additionalConfigurations={<CommunityConfigurator content={widget.config} onChange={onConfigChange} />}
      >
        <div className='widget-configuration_info-box'>
          <strong>✨ How to edit community category card</strong>
          <p>
            Please go to{' '}
            <a target='_blank' rel='noreferrer' href={`${controlUrl}/settings/category/overview`}>
              community category overview in control
            </a>{' '}
            to reorder the categories. And in each parent category page, you can change title, description and visual
            (thumbnail image) for every card.
          </p>
        </div>
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'banner') {
    return (
      <WidgetContainerConfigFields
        config={widget.config}
        showContentSection={false}
        widgetName='banner'
        nested={nested}
        onChange={onConfigChange}
      >
        <BannerConfigurator
          content={widget.config.content}
          buttons={widget.config.buttons}
          image={widget.config.image}
          onChange={(config) => {
            onConfigChange({
              content: {
                textAlignment: config.contentTextAlignment,
                title: config.contentTitle,
                description: config.contentDescription
              },
              buttons: {
                primaryText: config.buttonsPrimaryText ?? '',
                primaryUrl: config.buttonsPrimaryUrl ?? '',
                secondaryText: config.buttonsSecondaryText,
                secondaryUrl: config.buttonsSecondaryUrl
              },
              image: {
                position: config.imagePosition,
                src: config.imageSrc
              }
            })
          }}
        />
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'ideation_pipeline') {
    return (
      <WidgetContainerConfigFields
        config={withDerivedTitle(widget.config, widget.title || widget.config.title)}
        widgetName='generic_hero'
        nested={nested}
        onChange={onConfigChange}
      >
        <IdeationPipelineConfigurator
          maxHeight={widget.config.maxHeight}
          column_1={widget.config.column_1}
          column_2={widget.config.column_2}
          column_3={widget.config.column_3}
          onChange={onConfigChange}
        />
      </WidgetContainerConfigFields>
    )
  }
  if (widget.type === 'header_navigation') {
    return (
      <HeaderNavigationConfiguration
        items={widget.config.items ? widget.config.items : []}
        logo={widget.config.logo ? widget.config.logo : ''}
        onChange={(config) => {
          onChange({
            type: widget.type,
            title: 'Mega Menu',
            config: {
              items: config.items,
              logo: config.logo
            }
          })
        }}
      />
    )
  }
  if (
    widget.type === 'product-updates_hero' ||
    widget.type === 'hero_banner' ||
    widget.type === 'ideation_hero' ||
    widget.type === 'generic_hero'
  ) {
    return (
      <WidgetContainerConfigFields
        config={{
          ...widget.config,
          title: widget.config.title ?? widget.config.headline,
          subtitle: widget.config.subtitle ?? widget.config.tagline
        }}
        widgetName='generic_hero'
        nested={nested}
        onChange={onConfigChange}
      >
        <GenericHeroConfigurator
          onChange={(config) => {
            onConfigChange({
              heroImage: config.heroImage,
              align: config.align
            })
          }}
          heroImage={widget.config.heroImage ?? ''}
          align={widget.config.align ?? (widget.type === 'hero_banner' ? 'center' : 'left')}
        />
      </WidgetContainerConfigFields>
    )
  }
  return null
}
